import type { InjectionKey, Ref } from 'vue'

export const LcFormContext = Symbol('overridden LcForm context') as InjectionKey<{
  containerId: Ref<string>
}>
